
export const loginStart = () => ({
    type: "LOGIN_START",
});

export const loginSuccess = (user) => ({
    type: "LOGIN_SUCCESS",
    payload: user,
});

export const loginFailure = (err) => ({
    type: "LOGIN_FAILURE",
    payload: err,
});

export const logout = ()=>({
    type : "LOGOUT",
});

export const registerStart = () => ({
    type: "REGISTER_START",
});

export const registerSuccess = (mess) => ({
    type: "REGISTER_SUCCESS",
    payload: mess,
});

export const registerFailure = (err) => ({
    type: "REGISTER_FAILURE",
    payload: err,
});
export const restartAuth = (err) => ({
    type: "RESTART",
});